var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 72,
    viewBox: "0 0 81 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 234250842"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 34.9451L13.2917 22.6534L39.5139 34.9451L68.1944 22.6534L79.6667 31.6673L69.8333 36.0377V59.5284L39.5139 71.0006L9.19444 59.5284V38.3193L1 34.9451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2917 22.6534L1 34.9451L9.19444 38.3193M13.2917 22.6534L39.5139 34.9451M13.2917 22.6534L19.8472 20.2402M39.5139 34.9451L28.8611 46.4173L9.19444 38.3193M39.5139 34.9451L50.1667 44.7784L69.8333 36.0377M39.5139 34.9451L68.1944 22.6534M39.5139 34.9451V71.0006M68.1944 22.6534L79.6667 31.6673L69.8333 36.0377M68.1944 22.6534L61.0243 20.2402M39.5139 71.0006L69.8333 59.5284V36.0377M39.5139 71.0006L9.19444 59.5284V38.3193",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector 234250843"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 34.943L13.2917 22.6514L39.5139 34.943L68.1944 22.6514L79.6667 31.6653L69.8333 36.0356L50.1667 44.7764L39.5139 34.943L28.8611 46.4153L9.19444 38.3172L1 34.943Z",
    fill: "#FCA66C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5139 34.943L28.8611 46.4153L9.19444 38.3172L1 34.943L13.2917 22.6514L39.5139 34.943ZM39.5139 34.943L50.1667 44.7764L69.8333 36.0356L79.6667 31.6653L68.1944 22.6514L39.5139 34.943Z",
    stroke: "#383434",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008678"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.6111 14.4454V1.00098",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.1111 7.11209L40.6111 1.00098L46.1111 7.11209",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1015",
    d: "M51 14.4453C51 20.5204 46.0751 25.4453 40 25.4453C33.9249 25.4453 29 20.5204 29 14.4453",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.6aa4e8c9dd56150a89d957e8f348f318.svg";
export { ForwardRef as ReactComponent };